import './index.scss'
import Questionizer from './components/questionizer';
import { useEffect, useState } from 'react';
import { useQuestionizerStore } from './types/state';

import Toggle from "./components/toggle.tsx";

const CONFIGS = [
  {
    label: "Gebäude",
    path: "/client-configs/gebauede.json",
    icon: "client-icons/universal/gebaeude.svg",
    icon_active: "client-icons/active/gebaeude.svg",
  },
  {
    label: "Mobilität",
    path: "/client-configs/mobile.json",
    icon: "client-icons/universal/mobilitaet.svg",
    icon_active: "client-icons/active/mobilitaet.svg",
  },
  {
    label: "Infrastruktur",
    path: "/client-configs/infra.json",
    icon: "client-icons/universal/infrastruktur.svg",
    icon_active: "client-icons/active/infrastruktur.svg",
  },
  {
    label: "Umwelt & Klima",
    path: "/client-configs/umwelt.json",
    icon: "client-icons/universal/naturschutz-umweltschutz-biodiversitaet.svg",
    icon_active: "client-icons/active/naturschutz-umweltschutz-biodiversitaet.svg",
  }
];

export default function App(props: {configBase: string | null | undefined}) {
  const configPath = useQuestionizerStore((s) => s.configPath);
  const config = useQuestionizerStore((state) => state.config);
  const loadConfig = useQuestionizerStore((state) => state.loadConfig);
  const requestStatistics = useQuestionizerStore((state) => state.requestStatistics);
  const [baseConfig, setBaseConfig] = useState<any>(null);
  const sendStatisticsInterval = 3000; 

  useEffect(() => {
    if (!props.configBase) return;
    fetch(props.configBase)
      .then(res => res.json())
      .then(setBaseConfig)
      .catch(console.error);
  }, [props.configBase]);

  useEffect(() => {
    if (!configPath || !config) return;

    requestStatistics();
    const interval = setInterval(() => {
      requestStatistics();
    }, sendStatisticsInterval);

    return () => clearInterval(interval);
  }, [configPath, config]);
	
  if (!baseConfig) return null;
  const baseurl = baseConfig.baseurl;

  if (!configPath) {
    return (
      <div className="questionizer-container start w-full h-full flex flex-col font-sans">
        <h1 className="form__title">Finden Sie die passenden Fördermittel für Ihr Vorhaben! </h1>
		<p>
		Der Fördermittelkompass zeigt in wenigen Schritten, welche Fördermittel für individuelle Vorhaben in Frage kommen. Kommunen, Unternehmen sowie Bürgerinnen und Bürger, aber auch Forschungseinrichtungen und Organisationen können hier nach geeigneten Förderprogrammen suchen.
		Dabei werden Programme von EU, Bund, Ländern, Kommunen und Energieversorgern einbezogen. 
		</p>
		<p>
		Klicken Sie den gewünschten Bereich an und starten Sie damit die Fördermittelsuche: 
		</p>
        <div className="form from-start">
			 <div className=" section section-0">
				<div className="section__inputs section__inputs--grid">
					{CONFIGS.map((c, idx) => (
					 
					  <Toggle
						key={c.path}
						id={idx.toString()}
						label={c.label}
						icon={baseurl + c.icon}
						icon_active={baseurl + c.icon_active}
						value={false}
						onChange={() => loadConfig(baseurl + c.path)}
					  />
					
					))}
				</div>
		   </div>
         </div>
      </div>
    );
  }

  if (!config) { return; }
 // if (!props.configPath || !config) { return; }

  let style = config.style;
  let parsed_style = Object.keys(style)
    .map(element => [element, element.split(',').map(s => ".fbq "+s).join(',')])
    .map(element => `${element[1]}{${Object.keys(style[element[0]])
      .map( s => `${s.toString()}:${style[element[0]][s]}`)
      .join(';')}}`)
    .join(' ');
  
    return <>
        <style>{parsed_style}</style>
        <Root />
    </>
  }

function Root(){
  return <div className={"questionizer-container w-full h-full flex flex-col font-sans "}>
      <Questionizer />
  </div>
}